/**
 * Converts an object's values to strings.
 * If a value is `null` or `undefined`, it will be converted to an empty string.
 *
 * @param object - The object whose values need to be converted to strings.
 * @returns An object with the same keys as the input object, but with string values.
 */
export const getStringValuesObject = (object: Record<string, unknown>) => {
  const formattedEntries = Object.entries(object).map(([key, value]) => [
    key,
    `${value || ''}`,
  ]);

  return Object.fromEntries(formattedEntries);
};